import { useState } from "react";
import { Alert, Button, Modal, Collapse, Descriptions, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import usePdfBlob from "../../hooks/usePdfBlob";
import PdfPreviewer from "../PdfPreviewer";

const { Panel } = Collapse;

const PdfModalContent = ({ endpoint, submissionId }) => {
  const { pdfBlobUrl, loading, error } = usePdfBlob({
    endpoint,
    params: { submission_id: submissionId },
    enabled: !!submissionId,
  });

  if (error) {
    return <Alert type="error" message={error} showIcon />;
  }

  // Show spinner while fetch is in progress or hasn't resolved yet
  const isLoading = loading || (!pdfBlobUrl && !!submissionId);

  return <PdfPreviewer pdfBlobUrl={pdfBlobUrl} loading={isLoading} height="600px" />;
};

const ViewingFormButton = ({
  contents = {},
  viewingDataConfig = [],
  viewingType,
  viewingPdfEndpoint,
  viewingModalWidth = 800,
  buttonText = "View Submission",
  isIcon = false,
  hideTrigger = false,
  open: openProp,
  onOpenChange,
}) => {
  const [internalOpen, setInternalOpen] = useState(false);

  const isControlled = openProp !== undefined;
  const isOpen = isControlled ? openProp : internalOpen;

  const openModal = () =>
    isControlled ? onOpenChange?.(true) : setInternalOpen(true);
  const closeModal = () =>
    isControlled ? onOpenChange?.(false) : setInternalOpen(false);

  return (
    <>
      {!hideTrigger && (
        <Tooltip title={buttonText}>
          <Button
            shape={isIcon ? "circle" : undefined}
            icon={<EyeOutlined />}
            type="primary"
            onClick={openModal}
          >
            {isIcon ? null : buttonText}
          </Button>
        </Tooltip>
      )}

      <Modal
        open={isOpen}
        title="Submission Preview"
        footer={null}
        onCancel={closeModal}
        width={viewingModalWidth}
      >
        {viewingType === "pdf" && viewingPdfEndpoint ? (
          <PdfModalContent
            endpoint={viewingPdfEndpoint}
            submissionId={contents?.submission_id}
          />
        ) : (
          <Collapse defaultActiveKey={["1"]}>
            {viewingDataConfig.map(({ key, collapseName, collapseItems }) => (
              <Panel header={collapseName} key={key}>
                <Descriptions bordered column={1} size="small">
                  {collapseItems.map(({ name, label, render }) => (
                    <Descriptions.Item label={label} key={name}>
                      {render ? render(contents?.[name]) : (contents?.[name] || "-")}
                    </Descriptions.Item>
                  ))}
                </Descriptions>
              </Panel>
            ))}
          </Collapse>
        )}
      </Modal>
    </>
  );
};

export default ViewingFormButton;
